import classNames from 'classnames';
import React from 'react';

import { InfoLabel } from '@eika/label';

import type { Currency, EFakturaId } from '../../../generated-types';
import { EfakturaLink } from '../../EfakturaLink';
import { currencyFormatter } from '../../shared/numberFormat';

import './TransactionAmount.scss';

type Props = {
    value?: number;
    currency?: Currency;
    instructedAmount?: number;
    instructedCurrency?: Currency;
    typeLabel?: string;
    eFakturaId?: EFakturaId;
    eFakturaLoading?: boolean;
    additionalInfo?: string;
    eFakturaLinkClassName?: string;
};

export default ({
    value = 0,
    currency = 'NOK',
    instructedAmount,
    instructedCurrency,
    typeLabel,
    eFakturaId,
    eFakturaLoading = false,
    additionalInfo,
    eFakturaLinkClassName,
}: Props) => {
    return (
        <div className="transaction-details__receiver">
            {typeLabel && <InfoLabel size="small" text={typeLabel} />}
            <div className="transaction-details__receiver-amount-wrapper">
                <span className="transaction-details__receiver-amount">{currencyFormatter(value, currency)}</span>
                {typeof instructedAmount === 'number' && instructedCurrency && (
                    <span className="transaction-details__receiver-instructed-amount">
                        {currencyFormatter(instructedAmount, instructedCurrency)}
                    </span>
                )}
                {additionalInfo && <span className="transaction-details__additional-info">{additionalInfo}</span>}
            </div>
            <EfakturaLink
                loading={eFakturaLoading}
                className={classNames('transaction-details__efaktura-link', eFakturaLinkClassName)}
                eFakturaId={eFakturaId}
            />
        </div>
    );
};
